import { Errors } from '../errors';
import { axIsXMLCollection } from './axIsXMLCollection';
export function axGetDescendants(object, mn, sec) {
    if (!axIsXMLCollection(object, sec)) {
        sec.throwError('TypeError', Errors.DescendentsError, object);
    }
    return object.descendants(mn);
}
